import axios from '../../../apis/Api'
import history, { logout } from '../../../history'
import { toast } from 'react-toastify'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import {
  GET_RSO_PERFORMANCE_REPORT,
  RESET_RSO_PERFORMANCE_REPORT,
} from '../../../Types'
import fileSaver from 'file-saver'
import * as XLSX from 'xlsx'

export const getRsoPerformanceReport = (requestData) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .post(`api/Reports/GetRsoPerformanceReport`, requestData)
    .then(({ data }) => {
      if (data && data?.response)
        dispatch({
          type: GET_RSO_PERFORMANCE_REPORT,
          payload: data.response,
        })
      dispatch(hideLoading())
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data) toast.error(error.response.data.Message ? error.response.data.Message : error.response.data.message)
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}

export const resetRsoPerformanceReport = () => async (dispatch) => {
  dispatch({
    type: RESET_RSO_PERFORMANCE_REPORT,
    payload: [],
  })
}

export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .post(`api/Reports/ExportRsoPerformanceReport`, requestData)
    .then(({ data }) => {
      const outputFilename = `RSO_Performance_Report_${Date.now()}`
      const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      const fileExtension = '.xlsx'

      const exportToCSV = (csvData, jobNumber, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData)
        if (ws) {
          var range = XLSX.utils.decode_range(ws['!ref'])
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + '1' // <-- first row, column number C
            if (!ws[address]) continue
            ws[address].v =
              ws[address].v == 'srNo'
                ? 'Sr. No'
                : ws[address].v == 'rsoName'
                ? 'RSO Name'
                : ws[address].v == 'userName'
                ? 'User Name'
                : ws[address].v == 'totalJobsAssigned'
                ? 'Total Jobs Assigned'
                : ws[address].v == 'totalActiveDays'
                ? 'Total Jobs Inducted'
                : ws[address].v == 'totalShopsPending'
                ? 'Total Shops Pending'
                : ws[address].v
          }
        }
        // var sheetName = `Job_Number_${jobNumber}`
        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        }
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const fileData = new Blob([excelBuffer], { type: fileType })
        fileSaver.saveAs(fileData, fileName + fileExtension)
      }
      exportToCSV(data.response, '', outputFilename)
      dispatch(hideLoading())
    })

    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data) toast.error(error.response.data.Message ? error.response.data.Message : error.response.data.message)
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}
